// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'components/styles/_media'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'
import Colors from 'components/styles/colors'
import type { Topic } from 'types/www/topic'

type PropTypes = {
  title: string,
  content: string,
  image: string,
  buttonTitle: string,
  linkUrl: string,
}

export default (props: PropTypes) => {
  return (
    <li className="biglist-special__item">
      <div className="top-ribbon" />
      <a
        className="biglist-special__bgimg"
        href={props.linkUrl}
        style={{ backgroundImage: 'url(' + props.image + ')' }}
      />
      <div className="biglist-special__detail">
        <div className="biglist-special__detailcont">
          <p className="biglist-special__ttl">{props.title}</p>
          <p className="biglist-special__text">{props.content}</p>
          <p>
            <a href={props.linkUrl} className="btn__small btn__style bg_blue">
              {props.buttonTitle}
            </a>
          </p>
        </div>
      </div>
      <div className="ribbon-areatop">
        <span className="ribbon-top" />
      </div>
      <div className="ribbon-areabottom">
        <span className="ribbon-bottom" />
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicContentItem/OneColumnSpecial/index.jsx